import { useFormikContext } from "formik";
import { FC, ReactNode } from "react";

import {
  ConfirmationButtons,
  ConfirmationButtonsProps,
} from "~/src/components/common/forms/ConfirmationButtons";

export type Props = {
  onCancelClick: ConfirmationButtonsProps["onCancelClick"];
  message: ReactNode;
  /** When true (e.g. server-side draft), cancel stays enabled even if the form is not dirty. */
  hasDraft?: boolean;
};

export const FormikConfirmationButtons: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ onCancelClick, message, hasDraft = false }) => {
  const { isSubmitting, isValid, dirty, submitForm } = useFormikContext();

  const cancelDisabled = !dirty && !hasDraft;

  return (
    <ConfirmationButtons
      disabled={!isValid && dirty}
      loading={isSubmitting}
      onCancelClick={onCancelClick}
      message={message}
      onConfirm={submitForm}
      cancelDisabled={cancelDisabled}
    />
  );
};
